export const locale = {
  lang: 'pt',
  data: {
    PRONOSTICO: {
      PRONOSTICO_SUCCESS: 'Sucesso',
      PRONOSTICO_ERROR: 'Erro',
      PRONOSTICO_COMMUNICATION_ERROR: 'Erro de comunicação'
    }
  }
}
